module.exports = __webpack_public_path__ + "static/signup-f146d434925520713f91b81122a92ba4.png";